import { render } from "./receive-member.vue?vue&type=template&id=a9ffb12e&scoped=true"
import script from "./receive-member.vue?vue&type=script&lang=js"
export * from "./receive-member.vue?vue&type=script&lang=js"

import "./receive-member.vue?vue&type=style&index=0&id=a9ffb12e&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9ffb12e"]])